module.exports = __webpack_public_path__ + "public/c1c09b296df000fd064aacb10d4499cd.svg";